import React from "react";
import { Circle } from "@networkraildigitalfactory/components";
import { CaretRight } from "phosphor-react";
import useNotificationDropdown from "../../hooks/modals/useNotificationDropdown";
import styles from "./NotificationFeed.module.css";

const NotificationFooter = () => {
  const { toNotifications } = useNotificationDropdown();
  return (
    <div className={styles.notificationModal__Footer}>
      <button
        type="button"
        className={styles.notificationModal__viewAllNotifications}
        name="toggle notifications"
        aria-label="View all notifications"
        onClick={toNotifications}
      >
        view all notifications
        <Circle color="#37519d" size={24} className={styles.notificationModal__chevron}>
          <CaretRight color="#ffffff" size={20} />
        </Circle>
      </button>
    </div>
  );
};

export default NotificationFooter;
